import { Bell } from "lucide-react";

export default function NotifyPanel({ notifications, markRead, deleteNotify }) {
    return (
        <div className="space-y-4 text-sm">
            {/* 🔹 Header */}
            <h2 className="flex items-center gap-2 font-semibold text-lg bg-gradient-to-r from-[#3B82F6] via-[#8B5CF6] to-[#E91E63] bg-clip-text text-transparent">
                <Bell className="text-[#8B5CF6]" size={18} />
                การแจ้งเตือน
            </h2>

            {/* 🔹 Empty State */}
            {notifications.length === 0 ? (
                <div className="text-gray-500 italic bg-white/60 backdrop-blur-md border border-[#e3e8f7] rounded-xl py-3 px-4 text-center">
                    ไม่มีการแจ้งเตือนในขณะนี้
                </div>
            ) : (
                notifications.map((n) => (
                    <div
                        key={n.id}
                        className={`flex items-start gap-3 p-4 rounded-2xl border backdrop-blur-md transition-all duration-300 
              ${n.read
                                ? "bg-white/60 border-[#e5e9f5] hover:shadow-[0_0_10px_rgba(139,92,246,0.15)]"
                                : "bg-gradient-to-r from-[#EEF2FF]/90 to-[#FCE7F3]/90 border-[#e0d7f7] shadow-[0_0_15px_rgba(139,92,246,0.25)]"
                            }`}
                    >
                        {/* 🔵 สถานะ */}
                        <span
                            className={`w-2.5 h-2.5 mt-2 rounded-full ${n.read ? "bg-gray-300" : "bg-[#8B5CF6]"
                                }`}
                        ></span>

                        {/* 🔹 เนื้อหาแจ้งเตือน */}
                        <div className="flex-1">
                            <div className="font-medium text-gray-800 flex items-center gap-2">
                                {n.title}
                                {!n.read && (
                                    <span className="text-[10px] bg-gradient-to-r from-[#3B82F6] to-[#E91E63] text-white px-2 py-0.5 rounded-full">
                                        ใหม่
                                    </span>
                                )}
                            </div>
                            <div className="text-xs text-gray-500">{n.time}</div>
                            <div className="text-sm mt-1 text-gray-700 leading-snug">{n.message}</div>
                        </div>

                        {/* 🔘 ปุ่มจัดการ */}
                        <div className="flex flex-col gap-1">
                            {!n.read && (
                                <button
                                    onClick={() => markRead(n.id)}
                                    className="text-[11px] px-2 py-1 rounded-md bg-gradient-to-r from-[#3B82F6]/20 to-[#8B5CF6]/20 
                    hover:from-[#3B82F6]/30 hover:to-[#E91E63]/30 text-[#6D28D9] font-medium transition"
                                >
                                    อ่านแล้ว
                                </button>
                            )}
                            <button
                                onClick={() => deleteNotify(n.id)}
                                className="text-[11px] px-2 py-1 rounded-md bg-red-100/70 hover:bg-red-200/80 text-red-600 font-medium transition"
                            >
                                ลบ
                            </button>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}
